

import {   useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../api/ApiService";
import { loginSuccessAllSens } from "../redux/slices/allSensorSlice";
import { addTerminalList, updateTerminal } from "../redux/slices/adminSlice";
import { useForm } from "react-hook-form";
import { isEqual } from "./EditModalDam";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Close, Code, Details, LocationOff, LocationOn, ModelTraining } from "@mui/icons-material";


const AddTerminal=({flag,data})=>{
  const [valid,setValid]=useState(false)
    const {currentAdmin,currentTerminals}=useSelector(state=>state.p.admin)
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    const {id}=useParams()
    const dispatch=useDispatch();
    const mainProp={deviceCode:flag==='edit'?data?.deviceCode:'',specs:flag==='edit'?data?.specs:'',installedLocation:flag==='edit'?data?.installedLocation:'',version:flag==='edit'?data?.version:''}
    const {
        watch,
          register,
          handleSubmit,
          formState: { errors }
        } = useForm({defaultValues:mainProp});
    const AddNewTerminal=async(data)=>{
      const dataa={...data,farmId:currentAdmin?.id}
            const res=await apiService.addTerminals(dataa);
            dispatch(addTerminalList([...currentTerminals,res.data]))
            openModalls()
    }
    const editTerminal=async(data)=>{
            const res=await apiService.editTerminal(id,data);
            dispatch(updateTerminal(res.data))
            openModalls()
    }
    const allData=watch();
    useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])
    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={flag==='edit'?handleSubmit(editTerminal):handleSubmit(AddNewTerminal)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <AddToPhotosIcon fontSize="large"/>

            {flag!=='edit'&&<h4 > ایجاد ترمینال جدید</h4>}
            {flag==='edit'&&<h4 > به روزرسانی ترمینال </h4>}
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("specs", {
              required: 'این مقدار ضروری می باشد'
            })}/>
            <label for="" className={'labelSS'}><Details fontSize="small"/> توضیحات ترمینال </label>
            {errors?.specs?.message&&<span className='errMsg'>{errors?.specs?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("deviceCode", {
              required: 'این مقدار ضروری می باشد'
            })}/>
            <label for="" className={'labelSS'}><Code fontSize="small"/> کد ترمینال </label>
            {errors?.deviceCode?.message&&<span className='errMsg'>{errors?.deviceCode?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("installedLocation", {
              required: 'این مقدار ضروری می باشد'
            })}/>
            <label for="" className={'labelSS'}><LocationOn fontSize="small"/> محل نصب </label>
            {errors?.installedLocation?.message&&<span className='errMsg'>{errors?.installedLocation?.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("version",{required:'این مقدار ضروری است',pattern:{
                value:/^.{1,50}$/,
                message:'    حداکثر 50 کاراکتر'
            }})}/>
            <label for="" className={'labelSS'}><ModelTraining fontSize="small"/> ورژن   </label>
            {errors?.version?.message&&<span className='errMsg'>{errors.version.message}</span>}
        </div>
        {flag!=='edit'&&<button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>}
        {flag==='edit'&&<button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>}
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  AddTerminal